import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import PrivacyPolicy from '../';
import { useModalControls } from '../../../hooks/use-modal-controls';
import LinkText from '../../LinkText';
import Modal from '../../Modal';
import styles from './styles.css';

const cx = classNames.bind(styles);

const PrivacyPolicyLink = ({ className }) => {
  const [visible, closing, toggleModal] = useModalControls();
  return (
    <>
      <LinkText className={cx('text', className)} onClick={toggleModal}>
        Privacy Policy
      </LinkText>
      <Modal visible={visible} closing={closing} toggleModal={toggleModal}>
        <PrivacyPolicy />
      </Modal>
    </>
  );
};

export default PrivacyPolicyLink;

PrivacyPolicyLink.propTypes = {
  className: PropTypes.string
};
